import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "map-footer" }
const _hoisted_2 = { class: "map-footer__info" }
const _hoisted_3 = {
  key: 0,
  class: "ml-12"
}
const _hoisted_4 = {
  key: 1,
  class: "ml-24"
}
const _hoisted_5 = { class: "map-footer__info-text" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _cache[0] || (_cache[0] = _createElementVNode("span", null, " EPSG: 3857 ", -1)),
      (_ctx.lonLatStr)
        ? (_openBlock(), _createElementBlock("span", _hoisted_3, _toDisplayString(_ctx.lonLatStr), 1))
        : _createCommentVNode("", true),
      (_ctx.ratioStr)
        ? (_openBlock(), _createElementBlock("span", _hoisted_4, _toDisplayString(_ctx.ratioStr), 1))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("p", _hoisted_5, _toDisplayString(_ctx.$t('footer.kosovoBorderLabel')), 1)
  ]))
}